import request from '@/api/request';
const billingRequest = request(process.env.BILLING_API);
const simRequest = request(process.env.SIM_API);

export function LockVehicle (id) {
  let data = { id: id };
  return billingRequest({
    url: 'api/Vehicle/Lock',
    method: 'put',
    data
  });
}

export function UnlockVehicle (id) {
  let data = { id: id };
  return billingRequest({
    url: 'api/Vehicle/UnLock',
    method: 'put',
    data
  });
}

export function SearchSim (params) {
  return simRequest({
    url: '/sim/search',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/billing.js